import { useTranslation } from 'react-i18next';
import { redirectToLogin } from 'utils/location';
import { SimpleErrorModal } from './SimpleErrorModal';

export const SessionExpiredModal = () => {
  const { t } = useTranslation();

  return (
    <SimpleErrorModal
      title={t('session_expired_title')}
      description={t('session_expired_description')}
      buttonText={t('session_expired_button')}
      buttonAction={() => redirectToLogin()}
    />
  );
};
